<div class="inner-content" role="dialog" aria-modal="true" ridangoAppTrapFocus>
    <div class="flex-align-center bottom-0 left-0 right-0 top-0 !flex">
        <div class="flex-column flex h-full w-full rounded-2xl bg-white text-base">
            <div class="flex-align-center relative my-6 !flex">
                <h2 class="align-center flex-1 font-semibold" mat-dialog-title tabindex="-1" data-modal-title>
                    {{ 'TICKET_ACTIVATE_MANUAL_BTN' | translate }}
                </h2>
            </div>
            <div class="align-center box-border flex-1 overflow-y-auto px-4" mat-dialog-content>
                {{ 'TICKET_ACTIVATE_MANUAL_SAME_VALIDITY_CONFIRM_TEXT' | translate }}
            </div>

            <div class="m-4 mt-0">
                <ion-button
                    class="btn--link btn--maximal btn--big link--no-line link--no-hover orb-app-light:text-secondary mt-4 rounded-lg text-primary dark:text-contrast-yellow"
                    (click)="cancel()"
                    mat-dialog-close
                    size="large"
                    fill="clear">
                    <ion-label class="text-base font-semibold normal-case">
                        {{ 'DIALOG_BUTTON_CANCEL' | translate }}
                    </ion-label>
                </ion-button>

                <div class="flex">
                    <button
                        class="btn--primary vl-app-light:bg-[var(--btn-primary-color)] vl-app-light:text-black orb-app-light:text-black h-14 w-full rounded-lg font-bold shadow-[0px_1px_2px_0px_#0000004D] dark:bg-contrast-yellow dark:text-contrast-black"
                        (click)="confirmActivation()"
                        type="submit">
                        {{ 'TICKET_ACTIVATE_MANUAL_BTN' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
